var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._g({attrs:{"size":"14"}},_vm.$listeners),[_vm._v("pc-fechar")])}
var staticRenderFns = []

export { render, staticRenderFns }